// extracted by mini-css-extract-plugin
export default {"wrapper":"BreakdownTable_wrapper__I5-vM","table-head-cel":"BreakdownTable_table-head-cel__cD8+w","table-body-cel":"BreakdownTable_table-body-cel__uatD4"};